export enum Gender {
  Male = 1,
  Female = 2,
  NonBinary = 3,
  TransgenderMale = 4,
  TransgenderFemale = 5,
  Other = 6,
  DoesNotWishToDisclose = 7,
}

export enum NotifPref {
  All = 0,
  ExpirationsOnly = 1,
  None = 2,
}

export enum PatientFilter {
  NameOrId = "first_name|last_name|external_id",
}

export enum PatientsOperationsSection {
  Information = 1,
  LabAtHomeOPS = 2,
  Support = 3,
  Billing = 4,
}

export enum DateRange {
  All = "all",
  Last2Days = "last2days",
  Last30Days = "last30days",
  Last60Days = "last60days",
  Last90Days = "last90days",
}

export enum OrderTypeFilter {
  All = "all",
  InClinicOnly = "1",
  RkmPatients = "2_all",
  RkmCurrent = "2_current",
  RkmExpired = "2_expired",
}

export enum ReviewStatusFilter {
  All = "all",
  NotAccessed30Days = "not_accessed_30",
}
